import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'as-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  imports: [
    NgClass,
  ],
  standalone: true,
})
export class AsIconComponent implements OnInit {
  @Input() icon = 'error';
  @Input() size = 24;
  @Input() colorClass = '';
  @Input() color = '';
  svgContent: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.loadSvg();
  }

  async loadSvg() {
    const url = `assets/icons/${this.icon}.svg`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const svgText = await response.text();

      // Oznaczamy jako bezpieczny HTML, aby Angular nie usuwał zawartości
      this.svgContent = this.sanitizer.bypassSecurityTrustHtml(svgText);
    } catch (error) {
      console.error('Error loading SVG:', error);
    }
  }
}
